import { createBrowserRouter, Navigate } from "react-router-dom";
import Login from "./Login";
import DashboardPage from "./pages/Dashboard";
import ReportsPage from "./pages/Reports";
import Wrapper from "./components/Layout/Wrapper";
import ReportDetails from "./pages/ReportDetails";
import NewReport from "./pages/NewReport";
import Auth from "./utils/auth/authorization"

const AuthRoute = ({ component }) => {
  let Component = component;
  if (!Auth.isLoggedIn()) {
    return <Navigate to="/" />
  }
  return <Component />;
};

const routes = createBrowserRouter([
  {
    path: "/",
    element: <Login />,
  }, {
    path: "",
    element: <Wrapper />,
    children: [
      // {
      //   index: true,
      //   path: "/",
      //   element: <DashboardPage />,
      // },
      {
        path: "/reports",
        children: [
          {
            index: true,
            element: <AuthRoute component={ReportsPage} />,
          },
          {
            path: "new-report",
            element: <AuthRoute component={NewReport} />,
          },
          {
            path: ":id",
            element: <AuthRoute component={ReportDetails} />,
          },
          {
            path: ":reportId/edit",
            element: <AuthRoute component={NewReport} />,
          },
        ],
      },
    ]
  },
]);

export default routes;
